import { cn } from "../../../../utils/utils";

const StatusChip = ({ label, active, dot, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    className={cn(
      "inline-flex items-center gap-1.5 text-[11px] font-medium px-2 py-1 rounded-full ring-1 transition-colors",
      active
        ? "bg-indigo-600 text-white ring-indigo-600 shadow-sm"
        : "bg-white text-gray-700 ring-gray-200 hover:bg-gray-50",
    )}
  >
    {dot && (
      <span
        className={cn(
          "inline-block w-1.5 h-1.5 rounded-full",
          active ? "bg-white" : dot,
        )}
      />
    )}
    {label}
  </button>
);

export default StatusChip;
